export const styles = {
  style: {
    width: "100%"
  },
  divider: {
    // width: "100%",
    margin: 10
  }
};
